import { render, staticRenderFns } from "./RejectOrder.vue?vue&type=template&id=1059a1ae&"
import script from "./RejectOrder.vue?vue&type=script&lang=js&"
export * from "./RejectOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports